module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q2_2026_vibrant_code_btn.2e19c1fd.png";